import { useForm } from "react-hook-form";
import PermissionForm from "./PermissionForm";

const ModalAddPermission = (props) => {
  const { isOpen, onOk, onCancel } = props;
  const hookForm = useForm({
    defaultValues: {
      name: "",
      label: "",
      parent_id: null,
    },
  });
  return (
    <PermissionForm
      isOpen={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      hookForm={hookForm}
      title="Thêm permission"
      okText="Thêm"
    />
  );
};
export default ModalAddPermission;